import { useBaseAction } from "@framework/shared/hooks/useAction";

export type DarkModeActionResponse = {
  success: boolean;
};

export function useDarkModeAction() {
  return useBaseAction<DarkModeActionResponse>("/api/dark-mode");
}
